import { preventDefault } from '@lemonade-hq/cdk';
import { LinkButton } from '../LinkButton/LinkButton';
import { additionalText } from './Autocomplete.css';

// This is used to avoid the weird onBlur event that happens when clicking on action element (Safari and Iphone devices) https://stackoverflow.com/questions/17769005/onclick-and-onblur-ordering-issue
export const actionMouseDownHandler = preventDefault();

interface AutocompleteActionOptionProps {
  readonly label: string;
  readonly onClick?: VoidFunction;
}

export const AutocompleteActionOption: React.FC<AutocompleteActionOptionProps> = ({ label, onClick }) => (
  <LinkButton
    className={additionalText({ hasAction: onClick != null })}
    onClick={onClick}
    onMouseDown={actionMouseDownHandler}
    role="status"
    style={{
      position: 'relative',
    }}
  >
    {label}
  </LinkButton>
);
